// extracted by mini-css-extract-plugin
var _1 = "webpack-system-base-Stack-module__Stack";
export { _1 as "Stack" }
